var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OldValue = require('../old-value');

var Value = require('../value');

function _regexp(name) {
  return new RegExp("(^|[\\s,(])(".concat(name, "($|[\\s),]))"), 'gi');
}

var Intrinsic = /*#__PURE__*/function (_Value) {
  "use strict";

  _inherits(Intrinsic, _Value);

  var _super = _createSuper(Intrinsic);

  function Intrinsic() {
    _classCallCheck(this, Intrinsic);

    return _super.apply(this, arguments);
  }

  _createClass(Intrinsic, [{
    key: "regexp",
    value: function regexp() {
      if (!this.regexpCache) this.regexpCache = _regexp(this.name);
      return this.regexpCache;
    }
  }, {
    key: "isStretch",
    value: function isStretch() {
      return this.name === 'stretch' || this.name === 'fill' || this.name === 'fill-available';
    }
  }, {
    key: "replace",
    value: function replace(string, prefix) {
      if (prefix === '-moz-' && this.isStretch()) {
        return string.replace(this.regexp(), '$1-moz-available$3');
      }

      if (prefix === '-webkit-' && this.isStretch()) {
        return string.replace(this.regexp(), '$1-webkit-fill-available$3');
      }

      return _get(_getPrototypeOf(Intrinsic.prototype), "replace", this).call(this, string, prefix);
    }
  }, {
    key: "old",
    value: function old(prefix) {
      var prefixed = prefix + this.name;

      if (this.isStretch()) {
        if (prefix === '-moz-') {
          prefixed = '-moz-available';
        } else if (prefix === '-webkit-') {
          prefixed = '-webkit-fill-available';
        }
      }

      return new OldValue(this.name, prefixed, prefixed, _regexp(prefixed));
    }
  }, {
    key: "add",
    value: function add(decl, prefix) {
      if (decl.prop.includes('grid') && prefix !== '-webkit-') {
        return undefined;
      }

      return _get(_getPrototypeOf(Intrinsic.prototype), "add", this).call(this, decl, prefix);
    }
  }]);

  return Intrinsic;
}(Value);

Intrinsic.names = ['max-content', 'min-content', 'fit-content', 'fill', 'fill-available', 'stretch'];
module.exports = Intrinsic;